import type {IconName} from '@wandb/components';
import React, {type ReactNode} from 'react';

import {
  type SlurmConfirmVariant,
  SlurmJobConfirmModal,
} from './SlurmJobConfirmModal';

type SlurmRunRowMenuItemProps = {
  ddActionName: string;
  icon: IconName;
  label: string;
  onSelect: () => void;
};

type SlurmRunRowMenuItemsProps = {
  renderSeparator: () => ReactNode;
  renderItem: (props: SlurmRunRowMenuItemProps) => ReactNode;
  onCancel: () => void;
  onRequeue: () => void;
};

type SlurmRunRowConfirmModalProps = {
  entityName: string;
  projectName: string;
  runName: string;
  jobId: string;
  variant: SlurmConfirmVariant | null;
  onClose: () => void;
};

export function SlurmRunRowMenuItems({
  renderSeparator,
  renderItem,
  onCancel,
  onRequeue,
}: SlurmRunRowMenuItemsProps) {
  return (
    <>
      {renderSeparator()}
      {renderItem({
        ddActionName: 'Cancel slurm job',
        icon: 'do-not-prohibited',
        label: 'Cancel Slurm job',
        onSelect: onCancel,
      })}
      {renderItem({
        ddActionName: 'Requeue slurm job',
        icon: 'reset',
        label: 'Requeue Slurm job',
        onSelect: onRequeue,
      })}
    </>
  );
}

export function SlurmRunRowConfirmModal({
  entityName,
  projectName,
  runName,
  jobId,
  variant,
  onClose,
}: SlurmRunRowConfirmModalProps) {
  return (
    <SlurmJobConfirmModal
      isOpen={variant != null}
      variant={variant ?? 'cancel'}
      jobId={jobId}
      entityName={entityName}
      projectName={projectName}
      runName={runName}
      isRunLive={true}
      onClose={onClose}
    />
  );
}
